module.exports = __webpack_public_path__ + "static/media/blog3.a1c96a0e.md";